import { API_GATEWAY_URL } from 'shared/consts/consts';
import { serialize } from 'shared/helpers';

import BaseService from 'services/baseService';

const genericProxyRequestUrl = '/genericProxyRequest/';
const v2genricProxyUrl = '/v2/genericProxyRequest/';
const getColumnsUrl = '/api/v2/columns';

const genericProxyApi = new BaseService(genericProxyRequestUrl);
const v2GenricProxyApi = new BaseService(v2genricProxyUrl);
const getColumnsApi = new BaseService(getColumnsUrl);
const apiGatewayRequest = new BaseService(API_GATEWAY_URL);

export const buildVoiceCampaignRetargetGroupExportPayload = (retargetGroupId, params) => ({
	targetApi: 'exportVoiceCampaignRetargetGroupData',
	replaceable_params: {
		retargetGroupId,
	},
	...params,
});

export const API = {
	getCampaigns(params) {
		return genericProxyApi.getRequest(serialize(params, '?'));
	},
	campaignAnalytics(params) {
		return v2GenricProxyApi.getRequestWithParams(params);
	},
	deleteCampaign(campaignId) {
		const params = {
			target_url: 'campaign',
			params: { campaign_id: campaignId },
		};

		return genericProxyApi.deleteRequest(serialize(params, '?'));
	},
	editCampaign(botTimezone, campaignId, campaignName) {
		const data = {
			bot_timezone: botTimezone,
			target_url: 'campaign',
			campaign_name: campaignName,
			campaign_id: campaignId,
		};

		return genericProxyApi.putRequest(data);
	},
	saveCampaign(botTimezone, campaignName) {
		const data = {
			bot_timezone: botTimezone,
			target_url: 'campaign',
			campaign_name: campaignName,
		};

		return genericProxyApi.postRequest(data);
	},
	deleteMessage(campaignMessageId) {
		const params = {
			target_url: 'campaignMessage',
			params: { campaign_message_id: campaignMessageId },
		};

		return genericProxyApi.deleteRequest(serialize(params, '?'));
	},
	getCampaignMessages(data) {
		return genericProxyApi.putRequest(data);
	},
	exportCampaignData(data) {
		const params = {
			targetApi: 'exportCampaignData',
		};

		return apiGatewayRequest.postRequest(data, serialize(params, '?'));
	},
	getColumns(params) {
		return getColumnsApi.getRequestWithParams(params);
	},
	getVoiceCampaignHistory(params) {
		const payload = {
			targetApi: 'getCampaignHistory',
			...params,
		};

		return apiGatewayRequest.getRequest(serialize(payload, '?'));
	},
	getVoiceCampaignDetails(campaignId) {
		const payload = {
			targetApi: 'getCampaignDetailsById',
			replaceable_params: {
				campaignId,
			},
		};

		return apiGatewayRequest.getRequest(serialize(payload, '?'));
	},
	getVoiceCampaignChildren(campaignId, params = {}) {
		const payload = {
			targetApi: 'getVoiceCampaignChildren',
			replaceable_params: {
				campaignId,
			},
			...params,
		};

		return apiGatewayRequest.getRequest(serialize(payload, '?'));
	},
	exportVoiceCampaignData(params) {
		const payload = {
			targetApi: 'exportVoiceCampaignData',
			...params,
		};

		return apiGatewayRequest.postRequest({}, serialize(payload, '?'));
	},
	exportVoiceCampaignRetargetGroupData(retargetGroupId, params) {
		return apiGatewayRequest.postRequest(
			{},
			serialize(buildVoiceCampaignRetargetGroupExportPayload(retargetGroupId, params), '?')
		);
	},
	getVoiceCampaignExportStatus(exportId) {
		const payload = {
			targetApi: 'getVoiceCampaignExportStatus',
			replaceable_params: {
				exportId,
			},
		};

		return apiGatewayRequest.getRequest(serialize(payload, '?'));
	},
	getVoiceCampaignExportHistory(page = 1, size = 10) {
		const payload = {
			targetApi: 'getVoiceCampaignExportHistory',
			page: page - 1,
			size,
		};

		return apiGatewayRequest.getRequest(serialize(payload, '?'));
	},
	createVoiceCampaign(data) {
		const payload = {
			targetApi: 'createVoiceCampaign',
		};

		return apiGatewayRequest.postRequest(data, serialize(payload, '?'));
	},
	pauseVoiceCampaign(campaignId) {
		const payload = {
			targetApi: 'pauseVoiceCampaign',
			replaceable_params: { campaignId },
		};

		return apiGatewayRequest.postRequest({}, serialize(payload, '?'));
	},
	stopVoiceCampaign(campaignId) {
		const payload = {
			targetApi: 'stopVoiceCampaign',
			replaceable_params: { campaignId },
		};

		return apiGatewayRequest.postRequest({}, serialize(payload, '?'));
	},
	resumeVoiceCampaign(campaignId) {
		const payload = {
			targetApi: 'resumeVoiceCampaign',
			replaceable_params: { campaignId },
		};

		return apiGatewayRequest.postRequest({}, serialize(payload, '?'));
	},
};
